<div class="grid-item-list-wrapper grid-item-list-wrapper-length-{{ items.length }}" #scrollAnchor>
  <ng-container #masonryContainer></ng-container>

  @if (!masonryLoaded) {
    <!-- SSR Placeholder: Simple grid layout -->
    <div class="masonry-placeholder">
      @for (media of displayedVideos; track media.id; let index = $index) {
        <div
          #videoGridItem
          class="video-grid-item placeholder-item"
          (click)="itemClicked.emit({ media: media, index: index })"
        >
          <div class="card-wrapper" [style.paddingTop.%]="media.inverseRatio * 100">
            <div class="card-content">
              <div class="card-header h4">
                {{ media.title }}
              </div>
              <mb-media
                [media]="media"
                [class.media-image]="media.type === 'image'"
                [hoverplay]="true"
                [hideTitles]="true"
              ></mb-media>
              <div class="card-footer">
                <ul class="meta-items">
                  <li class="meta-item">{{ media.extension }}</li>
                  <li class="meta-item">{{ media.filesize | fileSize }}</li>
                </ul>
                @if (buttonItems.length) {
                  <mb-action-container
                    [buttonItems]="buttonItems"
                    [resource]="media"
                    (actionClick)="itemActionClicked.emit({ action: $event, media: media })"
                  ></mb-action-container>
                }
              </div>
            </div>
          </div>
        </div>
      }
    </div>
  }
</div>

@if (showButtons) {
  <div class="gallery-btn-wrapper">
    @if (!allVideosVisible) {
      <div (click)="onPagerButtonClick()" class="btn btn-secondary">
        {{ 'SHOW_MORE' | translate }}
      </div>
    }
    @if (!allVideosVisible) {
      <div (click)="onToggleAllClick()" class="btn btn-secondary">
        {{ 'SHOW_ALL' | translate }}
      </div>
    } @else {
      <div (click)="onToggleAllClick()" class="btn btn-secondary">
        {{ 'SHOW_LESS' | translate }}
      </div>
    }
  </div>
}
